// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  app: "MANALYTICS_WEB",
  // url: 'http://192.168.40.31:5556/api/v1', 
  
  // url: 'http://localhost:5556/api/v1',
  url: 'https://crystobol-test.metropol.co.ug/api/v1',
  key_username: 'KRUlejapQOoltdISEuy4eplnVqbQVlyf',
  key_password: 'LYQjkaZ5ImeMiymY',
  grant_type: 'password',
  grant_type_cc: 'client_credentials'
};
// "source_id": 3

// {
//   "public_key": "d1tVmshm5kENrXRsQgblnt9XiJ1BKVfj",
//   "private_key": "lrgt6SRCJwtZrTdI",
//   "app": "MANALYTICS_WEB"
// }
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
